<template>
  <div>
    <h3>上海友康信息科技有限公司用户服务协议</h3>
     <h4>前言</h4>
    欢迎您选择使用上海友康信息科技有限公司的移动端应用！
    本应用将遵循国家相关规定，努力为用户提供优质的产品和服务。 <h4>重要须知：</h4>
    一、您在使用通过本应用(下文亦称为“产品”）及相关服务之前，请仔细阅读本《用户服务协议》（下文亦称为“本协议”）中各条款。本协议系由用户（下文亦称为
    “您”）与我们就我们所提供的产品和服务所订立的协议。本应用特别提醒您认真阅读本协议的全部条款，特别是其中免除或者限制本应用责任的条款（该等条款通常含有“不负任何责任”、“无义务”、“不保证”等词汇）、限制用户权利的条款（该等条款通常含有“不得”、“不应”、“无权”等词汇）、法律适用和争议解决条款，这些条款应在中国法律所允许的范围内最大程度地适用，该类条款通常用粗体标示。
    二、如果您获得并使用我们所提供的产品和服务，则应视为您已经详细阅读了本协议的内容，同意本协议的内容，并同意遵守本协议的规定。本协议目的为告知您在申请，购买和使用我们所提供的产品和服务或其他任何可能影响您、我们权益时，应注意及遵守之事项。我们有时会更新本协议及其他规则的内容，您应不时地检查我们对本协议及其他规则进行的任何更新。
    <h4>第一条、 用户信息提供、使用与保管</h4> 1.
    用户承诺以其真实身份提供给本应用，并以该信息接受本应用服务。考虑到为您提供产品和服务的重要性，您同意：
    （1）向我们提供及时、详细及准确的个人资料；
    （2）您将不断更新个人资料，以符合及时、详细及准确的要求；
    （3）所有由您提供的个人资料将被我们用来作为识别和认定用户身份的唯一证据。
    如果您所提供的身份资料与事实不符或已变更而未更新或有任何误导之嫌，导致我们无法为您提供或进一步提供产品和服务，我们将不承担任何责任。
    2.修改您的个人资料 您可以在任何时候更新或修改您的个人资料。
    3.根据必备条款的约定，本应用有权审查您所提供的身份信息是否真实、有效，并会积极地采取技术与管理等合理措施保障信息的安全、有效。
    <h4>第二条、 用户信息的披露与保护</h4> 1.
    未经您的许可本应用不得向任何第三方提供、公开或共享您注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：
    （1）您允许我们披露这些个人资料；
    （2）有关法律法规或行政规章要求我们披露您的个人资料。
    （3）司法机关或行政机关基于法定程序要求我们披露您的个人资料。
    （4）为保护我们的知识产权和维护其他财产权益等合法利益时，需要披露您的个人资料。
    （5）在紧急情况下为保护其他用户和社会公众的财产人身安全，需要披露您的个人资料。
    2.
    除前述个人信息资料之外，您同意并授权本应用基于行政/司法机关的要求或安全、用户体验优化等考虑而收集您的其他必要信息，但本应用仅可为履行本协议之目的收集与利用该等信息。
    3.我们将采取商业上合理的方式以保护您的个人资料的安全。我们将使用通常可以获得的安全技术和程序来保护您的个人资料不被未经授权的访问、使用或泄漏。对于非因我们的疏忽而造成您个人资料的泄密，我们不承担责任。
    <h4>第三条、 您的权利</h4>
    1.您可以根据本协议以及我们不时更新和公布的其他规则使用我们提供的产品和服务。
    2.您有权在使用我们提供的产品和服务的期间监督我们及我们的工作人员是否按照我们所公布的标准向您提供产品和服务，也可以随时向我们提出与我们的产品和服务有关意见和建议。
    3.如果您不同意本协议或对我们后来更新的协议有异议，或对我们所提供产品和服务不满意，您可以选择停止使用我们的产品和服务。如果您选择停止使用我们的产品和服务，则我们即不再对您承担任何义务和责任。
    <h4>第四条、 服务的终止</h4>
    1.您同意在您有下列情况下，我们有权终止向您提供产品和服务：
    （1）违反本协议的规定。 （2）提供虚假注册信息。
    （3）通过非法手段、不正当手段或其他不公平的手段使用我们的产品和服务或参与我们活动。
    （4）有损害我们正当利益的行为。 （5）有严重损害其他用户的行为。
    （6）有违反中国的法律、法规的行为或言论。
    （7）有违背社会风俗、社会道德和互联网一般道德和礼仪的行为。
    （8）其他妨碍我们提供产品和服务或我们认为的严重不当行为。
    我们因上述原因终止服务后即不再对您承担任何义务和责任。 <h4>第五条、中断、更改、停止服务及个人资料的转移</h4>
    1.为了向您提供产品和服务，我们可能会需要定期或不定期地对有关的服务器设备或平台进行维护，该维护可能造成服务的中断，并且该中断可能没有事先的通知，对于由此引起的中断我们不承担任何责任。您已经了解并同意，对于因我们、我们的合作方或电信网络系统软硬件设备的故障、失灵或人为操作的疏失而全部或部分中断、暂时无法使用、迟延并造成我们提供产品和服务的停止或中断的，我们不承担任何责任；对于因他人侵入我们的网络或系统，篡改、删改或伪造、变造资料或数据而造成我们的产品和服务的停止或中断，我们也不承担任何责任。
    2.您已经了解并同意，我们可能在相关官方网站首页或其他我们选择的方式通知后中止或终止服务，但您违反本协议或其他用户规则的处理不在此例。我们将尽力持续地向您提供产品和服务，但是我们并不排除我们可能会更改或停止提供该产品和服务的可能性。如果我们停止提供产品和服务，我们将会事先通知您，并尽力寻找适当的服务提供者以代替我们继续提供产品和服务。在这种情况下，我们可能会将您的个人资料（包括个人资料）转移给该继续提供服务的一方。您在此同意我们有权做此转移，并且同意在我们完成该转移之后，我们即不再对您承担任何义务和责任。我们并不在此保证我们届时肯定能够找到适当的服务提供者以代替我们继续提供产品和服务，或者我们找到的服务提供者所提供的产品和服务能够满足您的要求。
    3.应用的版本升级，不影响双方原先的权力义务关系 <h4>第六条、 有限保证及责任限制</h4>
    对于我们的产品和服务，我们仅作下述有限保证，该有限保证取代任何文档、包装、或其他资料中的任何其他明示或默示的保证（如果有）。我们仅以“现有状况且包含所有错误”的形式提供相关的产品、软件或程序及任何支持服务，并仅保证：(1)我们所提供的产品和服务能基本符合我们正式公布的要求，(2)我们所提供的相关产品和服务基本与我们正式公布的服务承诺相符，(3)我们仅在商业上允许的合理范围内尽力解决我们在提供产品和服务过程中所遇到的任何问题。在适用法律允许的最大范围内，我们明确表示不提供任何其他类型的保证，不论是明示的或默示的，包括但不限于适销性、适用性、可靠性、准确性、完整性、无病毒以及无错误的任何默示保证和责任。另外，在适用法律允许的最大范围内，我们并不担保我们所提供的产品和服务一定能满足您的要求，也不担保提供的产品和服务不会被中断，并且对产品和服务的及时性，安全性，出错发生，以及信息是否能准确，及时，顺利的传送均不作任何担保。
    <h4>第七条、 条款变更</h4>
    本应用有权在必要的时候修改本协议条款，敬请您定期查询有关内容。 <h4>第八条、
    不可抗力事件</h4>
    1.如因本服务范围之外并且不在本应用控制范围内的以下情形导致您不能使用本产品或服务的，本应用不因此对任何损害或赔偿负责。这些情形包含但不限于下列情况：
    (1) 本应用由于执行计划中的维修工作或者更新软件或硬件而中断本服务； (2)
    由于运行商系统故障或者网络连接故障造成的数据传送中断； (3)
    由不可抗力，例如台风、地震、停电、洪水、战争或者恐怖袭击、政府政策而造成的服务中断；
    (4) 由于第三方支付服务故障所引起的本服务功能故障； (5)
    由恶意软件、拒绝服务或者其它类型的黑客攻击而造成的系统服务中断。
    2.如果出现不可抗拒力事件，本应用保留终止本协议中的任一义务的履行和此不可抗拒力事件结束后在合理期间内重置本服务并继续其义务的权利。本应用将合理地尽力结束不可抗拒力事件或者找到一个能使本应用在这样的事件中仍然能够履行其义务的方法。
  </div>
</template>

<script>
export default {};
</script>

<style>
h3{
  font-size: 20px;
  margin: 10px 0;
  padding: 0;
  line-height: 35px;
  font-weight: 600;
}
h4{
  font-size: 18px;
  margin: 15px 0;
  padding: 0;
  font-weight: 600;
}
div{
  font-weight: 400;
  font-size: 16px;
  padding: 8px 8px;
  line-height: 23px;
}
</style>
